import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Info } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
import styles from './WithStatusIcon.module.scss';
export const GetWithStatusIconTID = (parentTestId)=>getTestIds(parentTestId);
/**
 * Adds an error icon with info after the content. Used for decorating a text section
 * with an error icon.
 */ export function WithStatusIcon(props) {
    const { children, info, as, className, statusType = 'error', size = 'small', enableOnMobile, testId } = props, rest = _object_without_properties(props, [
        "children",
        "info",
        "as",
        "className",
        "statusType",
        "size",
        "enableOnMobile",
        "testId"
    ]);
    const { WithStatusIconTID } = useMemo(()=>GetWithStatusIconTID(testId), [
        testId
    ]);
    const RootElement = as || 'div';
    return /*#__PURE__*/ _jsxs(RootElement, _object_spread_props(_object_spread({}, rest), {
        "data-testid": WithStatusIconTID.Root(),
        className: cn(styles.root, className),
        children: [
            children,
            /*#__PURE__*/ _jsx(Tooltip, {
                placement: "top",
                title: info,
                enableOnMobile: enableOnMobile,
                children: /*#__PURE__*/ _jsxs(Typography, {
                    skin: statusType,
                    children: [
                        size === 'small' && /*#__PURE__*/ _jsx(Info, {
                            size: 16
                        }),
                        size === 'medium' && /*#__PURE__*/ _jsx(Info, {
                            size: 20
                        })
                    ]
                })
            })
        ]
    }));
}
